(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mystery-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (form.dataset.mqReady === '1') return;
      form.dataset.mqReady = '1';

      var wrap = form.closest('.mq-wrap');
      var configEl = wrap && wrap.querySelector('.mq-config');
      if (!configEl) return;

      var config;
      try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
      if (!config.tiers || !config.tiers.length) return;

      var steps = Array.prototype.slice.call(form.querySelectorAll('.mq-step'));
      var progressItems = Array.prototype.slice.call(form.querySelectorAll('.mq-progress li'));
      var statusEl = form.querySelector('[data-mq-status]');
      var idInput = form.querySelector('[data-mq-id]');
      var summaryEl = form.querySelector('[data-mq-summary]');
      var submitBtn = form.querySelector('[data-mq-submit]');
      var backBtn = form.querySelector('[data-mq-back]');
      var notes = form.querySelector('[data-mq-notes]');
      var tierInputs = Array.prototype.slice.call(form.querySelectorAll('[data-mq-tier]'));
      var planWrap = form.querySelector('[data-mq-plans]');
      var planRow = form.querySelector('[data-mq-plan-row]');
      var planInput = form.querySelector('[data-mq-plan-input]');
      var renderedPlansFor = false;

      var current = 1;
      var soldOutText = form.dataset.mqSoldOut || '';

      function stepAfter(input) {
        var step = input.closest('.mq-step');
        var next = step ? Number(step.dataset.step) + 1 : current + 1;
        return Math.min(next, steps.length);
      }

      function selectedTierKey() {
        var hit = tierInputs.filter(function (i) { return i.checked && !i.disabled; })[0];
        return hit ? hit.value : null;
      }

      function tierByKey(key) {
        return config.tiers.filter(function (t) { return t.key === key; })[0] || null;
      }

      function showStep(n, skipFocus) {
        current = n;
        steps.forEach(function (step) {
          var isActive = Number(step.dataset.step) === n;
          step.hidden = !isActive;
          step.classList.toggle('is-active', isActive);
        });
        progressItems.forEach(function (item) {
          var index = Number(item.dataset.progress);
          item.classList.toggle('is-current', index === n);
          item.classList.toggle('is-done', index < n);
        });
        if (statusEl) statusEl.textContent = 'Stap ' + n + ' van ' + steps.length;
        if (backBtn) backBtn.hidden = n === 1;
        var legend = steps[n - 1] && steps[n - 1].querySelector('.mq-legend');
        // Niet focussen bij de eerste render: dat scrollt de pagina naar de quiz.
        if (legend && !skipFocus) legend.focus();
      }

      // Ook op click: een radio die al aanstaat vuurt geen change-event.
      // De current-check voorkomt dat click en change samen twee stappen vooruit springen.
      function advanceFrom(input) {
        var step = input.closest('.mq-step');
        if (!step) return;
        if (Number(step.dataset.step) !== current) return;
        showStep(stepAfter(input));
      }

      function refreshTiers() {
        tierInputs.forEach(function (input) {
          var tier = tierByKey(input.value);
          var usable = !!(tier && tier.available);
          input.disabled = !usable;
          var card = input.closest('.mq-card');
          if (card) {
            card.classList.toggle('is-disabled', !usable);
            var priceEl = card.querySelector('[data-mq-tier-price]');
            if (priceEl) priceEl.textContent = tier ? (usable ? tier.price : soldOutText) : soldOutText;
          }
          if (!usable && input.checked) input.checked = false;
        });
      }

      // Eén radio per selling plan van de gekozen box, met "eenmalig" (lege waarde)
      // vooraan. Boxen zonder plannen laten de fieldset verborgen.
      function renderPlans(tier) {
        if (!planWrap || !planRow) return;
        planRow.textContent = '';
        var plans = (tier && tier.plans) || [];
        if (!plans.length) {
          planWrap.hidden = true;
          return;
        }
        var name = planWrap.getAttribute('data-mq-plan-name') || 'mq-plan';
        var options = [{ id: '', name: planWrap.getAttribute('data-mq-one-time') || 'Eenmalig', price: tier.price }];
        plans.forEach(function (plan) { options.push(plan); });
        options.forEach(function (option, index) {
          var inputId = name + '-' + index;
          var label = document.createElement('label');
          label.className = 'mq-plan';
          label.setAttribute('for', inputId);
          var input = document.createElement('input');
          input.className = 'visually-hidden';
          input.type = 'radio';
          input.id = inputId;
          input.name = name;
          input.value = String(option.id);
          input.checked = index === 0;
          input.addEventListener('change', refreshSummary);
          var title = document.createElement('span');
          title.className = 'mq-planName';
          title.textContent = option.name;
          var price = document.createElement('span');
          price.className = 'mq-planPrice';
          price.textContent = option.price;
          label.appendChild(input);
          label.appendChild(title);
          label.appendChild(price);
          planRow.appendChild(label);
        });
        planWrap.hidden = false;
      }

      // Alleen opnieuw opbouwen bij een andere box: anders zou elke plankeuze
      // zichzelf meteen terugzetten op eenmalig.
      function syncPlans(tier) {
        var key = tier ? tier.key : null;
        if (key === renderedPlansFor) return;
        renderedPlansFor = key;
        renderPlans(tier);
      }

      function selectedPlan(tier) {
        if (!planWrap || planWrap.hidden || !planRow) return null;
        var hit = planRow.querySelector('input:checked');
        if (!hit || !hit.value) return null;
        return ((tier && tier.plans) || []).filter(function (plan) {
          return String(plan.id) === hit.value;
        })[0] || null;
      }

      function refreshSummary() {
        var tier = tierByKey(selectedTierKey());
        if (!tier || !tier.available) {
          syncPlans(null);
          if (idInput) idInput.value = '';
          if (planInput) planInput.value = '';
          if (summaryEl) summaryEl.textContent = '';
          if (submitBtn) { submitBtn.hidden = true; submitBtn.disabled = true; }
          return;
        }
        syncPlans(tier);
        var plan = selectedPlan(tier);
        var price = plan ? plan.price : tier.price;
        if (idInput) idInput.value = String(tier.id);
        if (planInput) planInput.value = plan ? String(plan.id) : '';
        if (summaryEl) {
          summaryEl.textContent = [tier.label, plan ? plan.name : null, price].filter(Boolean).join(' · ');
        }
        if (submitBtn) {
          submitBtn.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = (form.dataset.mqSubmitLabel || 'In je nachtkastje') + ' · ' + price;
        }
      }

      var questionSteps = Array.prototype.slice.call(form.querySelectorAll('[data-mq-question]'));

      questionSteps.forEach(function (step) {
        var multiple = step.hasAttribute('data-mq-multiple');
        var required = step.hasAttribute('data-mq-required');
        var inputs = Array.prototype.slice.call(step.querySelectorAll('[data-mq-answer]'));
        var target = step.querySelector('[data-mq-multi-target]');
        var nextBtn = step.querySelector('[data-mq-next]');

        if (!multiple) {
          inputs.forEach(function (input) {
            input.addEventListener('change', function () { advanceFrom(input); });
            input.addEventListener('click', function () { if (input.checked) advanceFrom(input); });
          });
          return;
        }

        function syncMulti() {
          var chosen = inputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
          if (target) target.value = chosen.join(', ');
          if (nextBtn && required) nextBtn.disabled = chosen.length === 0;
        }

        inputs.forEach(function (input) { input.addEventListener('change', syncMulti); });
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            showStep(Math.min(Number(step.dataset.step) + 1, steps.length));
          });
        }
        syncMulti();
      });

      tierInputs.forEach(function (input) {
        function advanceTier() {
          if (input.disabled || !input.checked) return;
          refreshSummary();
          advanceFrom(input);
        }
        input.addEventListener('change', advanceTier);
        input.addEventListener('click', advanceTier);
      });

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (current > 1) showStep(current - 1);
        });
      }

      form.addEventListener('submit', function (event) {
        if (!idInput || !idInput.value) { event.preventDefault(); return; }
        // Een lege selling_plan meesturen laat Shopify de toevoeging weigeren.
        if (planInput && planInput.value === '') planInput.disabled = true;
        if (notes && notes.value.trim() === '') notes.disabled = true;
        Array.prototype.slice.call(form.querySelectorAll('[data-mq-multi-target]')).forEach(function (input) {
          if (input.value.trim() === '') input.disabled = true;
        });
      });

      // Zodat de theme editor een specifieke stap kan tonen.
      form.mqShowStep = showStep;

      refreshTiers();
      refreshSummary();
      showStep(1, true);
    }

    function boot() {
      Array.prototype.slice.call(document.querySelectorAll('form[data-mq]')).forEach(init);
    }

    // Theme editor: spring naar de stap van het geselecteerde block.
    function onBlockSelect(event) {
      var detail = event.detail;
      var blockId = detail && detail.blockId;
      if (!blockId) return;
      // Een sectie die na de eerste boot is geladen, is misschien nog niet geïnitialiseerd.
      boot();
      var step = document.querySelector('[data-mq-question="' + blockId + '"]');
      if (!step) {
        // Tier-blocks delen één fieldset, dus zoek die via het bijbehorende keuzerondje.
        var tierInput = document.querySelector('[data-mq-tier][value="' + blockId + '"]');
        step = tierInput && tierInput.closest ? tierInput.closest('.mq-step') : null;
      }
      if (!step || !step.dataset || !step.dataset.step) return;
      var form = step.closest('form[data-mq]');
      if (!form || typeof form.mqShowStep !== 'function') return;
      form.mqShowStep(Number(step.dataset.step));
    }

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', onBlockSelect);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
